import styled from 'styled-components'

export const Container = styled.div`
  gap: 8px;
  display: flex;
  flex-direction: column;
`

export const SkillsContainer = styled.div`
  gap: 16px;
  display: flex;
  flex-direction: column;
`
